import { cacheKeys } from "@constants/cache-keys";
import { getUserInfo } from "@memorang/api-client";
import { useQuery } from "@tanstack/react-query";
import { useAppStore } from "./useAppStore";
import useClerkUser from "./useClerkUser";

const useUserInfo = () => {
	const appId = useAppStore((state) => state.app.id);
	const { email } = useClerkUser();

	const { data: userInfo } = useQuery({
		queryKey: [cacheKeys.userInfo, email],
		queryFn: async () => {
			if (!email) {
				return null;
			}
			return await getUserInfo(email, appId);
		},
		enabled: !!email,
	});

	return userInfo;
};

export default useUserInfo;
